module.exports = __webpack_public_path__ + "static/img/gutachten_1.b2b5b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gutachten_1.png
// module id = ciY6
// module chunks = 1